import { buildUrl, buildUrlWithParameters, get } from "../utils/axiosRequests";
import {
  DEFAULT_HTTP_TIMEOUT,
  MARQUESINAS_API_BUS_STOP_INFO,
  MARQUESINAS_API_BUS_STOPS,
} from "../utils/constants";

export const getBusStopInfoService = (
  bus_stop_id,
  parameters = {},
  callback,
  headers = {},
  errorCallback = undefined
) => {
  let url = buildUrl(MARQUESINAS_API_BUS_STOP_INFO, { bus_stop_id });
  url = `${buildUrlWithParameters(url, parameters)}`;
  get(
    url,
    { timeout: DEFAULT_HTTP_TIMEOUT },
    false,
    callback,
    errorCallback,
    headers
  );
};

export const getBusStopsService = (parameters = {}, callback) => {
  const url = buildUrlWithParameters(MARQUESINAS_API_BUS_STOPS, parameters);
  get(url, { timeout: DEFAULT_HTTP_TIMEOUT }, false, callback);
};
